import React from 'react';
import { Box, Typography, Divider, Chip, Paper } from '@mui/material';
import { Questionnaire, Question } from '../../types/questionnaire';
import { InputRenderer } from './renderers/InputRenderer';
import { RadioGroupRenderer } from './renderers/RadioGroupRenderer';
import { TextareaRenderer } from './renderers/TextareaRenderer';

interface QuestionnaireRendererProps {
  questionnaire: Questionnaire;
  answers: Record<string, any>;
  onAnswerChange: (questionName: string, value: any) => void;
}

// Фабрика для вибору рендерера
const getQuestionRenderer = (
  question: Question,
  answers: Record<string, any>,
  onAnswerChange: (questionName: string, value: any) => void,
) => {
  const currentValue = answers[question.name] || '';

  switch (question.component) {
    case 'input':
      return (
        <InputRenderer
          key={question.id}
          question={question}
          value={currentValue}
          onChange={onAnswerChange}
        />
      );
    case 'radio':
      return (
        <RadioGroupRenderer
          key={question.id}
          question={question}
          value={currentValue}
          onChange={onAnswerChange}
        />
      );
    case 'textarea':
      return (
        <TextareaRenderer
          key={question.id}
          question={question}
          value={currentValue}
          onChange={onAnswerChange}
        />
      );
    // TODO: Додати рендерери для 'select', 'checkbox-group' і т.д.
    default:
      return (
        <Paper key={question.id} sx={{ p: 2, mb: 2, backgroundColor: '#f5f5f5' }} variant="outlined">
          <Typography variant="body2" color="text.secondary">
            Рендерер для компонента <strong>'{question.component}'</strong> ще не реалізовано.
          </Typography>
        </Paper>
      );
  }
};

export const QuestionnaireRenderer: React.FC<QuestionnaireRendererProps> = ({ questionnaire, answers, onAnswerChange }) => {
  return (
    <Box>
      {questionnaire.steps?.map((step, index) => (
        <Box key={step.id} sx={{ mb: 4 }}>
          <Divider sx={{ mb: 3, mt: 3 }}>
            <Chip label={`Крок ${index + 1}: ${step.caption}`} />
          </Divider>
          {step.description && (
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              {step.description}
            </Typography>
          )}
          {step.questions.map((question) =>
            getQuestionRenderer(question, answers, onAnswerChange)
          )}
        </Box>
      ))}
    </Box>
  );
};
